module.exports = __webpack_public_path__ + "img/caret-right-square.ae164958.svg";